import { BaseOption } from "entities/common";

export type DeviceStatusKey = "online" | "offline" | "neverSeen";
export type CalibrationVariant = "calibrated" | "due" | "overdue";
export type StatTone = "gray" | "green" | "red" | "orange";

export type DeviceCalibration = {
  label: string;
  variant: CalibrationVariant;
  sub: string;
  certificate?: boolean;
};

export type DeviceRecord = {
  id: number;
  asset: string;
  location: string;
  deviceName: string;
  eui: string;
  status: DeviceStatusKey;
  battery: number | null;
  lastUpdate: string | null;
  calibration: DeviceCalibration;
};

export const STAT_CARDS: { key: string; title: string; value: string; tone: StatTone }[] = [
  { key: "total", title: "Total devices", value: "10", tone: "gray" },
  { key: "online", title: "Online", value: "8", tone: "green" },
  { key: "offline", title: "Offline", value: "2", tone: "red" },
  { key: "never_seen", title: "Never seen", value: "10", tone: "orange" },
];

export const HEADERS: { label: string; key: string }[] = [
  { label: "Asset", key: "asset" },
  { label: "Location", key: "location" },
  { label: "Device", key: "device" },
  { label: "Status", key: "status" },
  { label: "Battery", key: "battery" },
  { label: "Last update", key: "lastUpdate" },
  { label: "Calibration", key: "calibration" },
  { label: "Actions", key: "actions" },
];

export const ASSET_OPTIONS: BaseOption[] = [
  { value: "", label: "All assets" },
  { value: "downtown-commercial", label: "Downtown Commercial" },
  { value: "classroom-3b", label: "Classroom 3B" },
  { value: "conference-room-a", label: "Conference Room A" },
  { value: "main-lobby", label: "Main Lobby" },
];

export const TYPE_OPTIONS: BaseOption[] = [
  { value: "", label: "All types" },
  { value: "AM103", label: "Milesight AM103" },
  { value: "AM104", label: "Milesight AM104" },
  { value: "AM308", label: "Milesight AM308" },
  { value: "AM319 O3", label: "Milesight AM319 O3" },
  { value: "AM319 HCHO-IR", label: "Milesight AM319 HCHO-IR" },
  { value: "AM319 HCHO-IR-W", label: "Milesight AM319 HCHO-IR-W" },
];

export const STATUS_OPTIONS: BaseOption[] = [
  { value: "", label: "All statuses" },
  { value: "online", label: "Online" },
  { value: "offline", label: "Offline" },
  { value: "never_seen", label: "Never seen" },
];

export const STATUS_LABELS: Record<DeviceStatusKey, string> = {
  online: "Online",
  offline: "Offline",
  neverSeen: "Never seen",
};

const CALIBRATION_CALIBRATED: DeviceCalibration = {
  label: "Calibrated",
  variant: "calibrated",
  sub: "Next due: 01.01.2026",
  certificate: true,
};
const CALIBRATION_DUE: DeviceCalibration = {
  label: "Due in 12 days",
  variant: "due",
  sub: "Next due: 01.01.2027",
};
const CALIBRATION_OVERDUE: DeviceCalibration = {
  label: "Overdue",
  variant: "overdue",
  sub: "Was due: 01.01.2025",
};

const baseDevice = {
  asset: "Downtown Commercial",
  location: "Bathroom",
  deviceName: "WS302 Sound Level Sensor",
  eui: "2CF7F1C07330A99B",
};

export const DEVICES: DeviceRecord[] = [
  { id: 1, ...baseDevice, status: "neverSeen", battery: null, lastUpdate: null, calibration: CALIBRATION_CALIBRATED },
  { id: 2, ...baseDevice, status: "neverSeen", battery: null, lastUpdate: null, calibration: CALIBRATION_CALIBRATED },
  { id: 3, ...baseDevice, status: "online", battery: 80, lastUpdate: "13.04.2026 12:20", calibration: CALIBRATION_DUE },
  {
    id: 4,
    ...baseDevice,
    status: "offline",
    battery: 80,
    lastUpdate: "13.04.2026 12:20",
    calibration: CALIBRATION_OVERDUE,
  },
  { id: 5, ...baseDevice, status: "online", battery: 80, lastUpdate: "13.04.2026 12:20", calibration: CALIBRATION_DUE },
  {
    id: 6,
    ...baseDevice,
    status: "offline",
    battery: 80,
    lastUpdate: "13.04.2026 12:20",
    calibration: CALIBRATION_OVERDUE,
  },
  { id: 7, ...baseDevice, status: "online", battery: 80, lastUpdate: "13.04.2026 12:20", calibration: CALIBRATION_DUE },
  {
    id: 8,
    ...baseDevice,
    status: "offline",
    battery: 80,
    lastUpdate: "13.04.2026 12:20",
    calibration: CALIBRATION_OVERDUE,
  },
];
